import React from 'react';
import Container from 'react-bootstrap/Container';
import { t } from '../../../../../i18n';
import CoursesCarousel from '../../../../components/courses-carousel';

const RelatedCourses = ({ relatedCourses, handlePlayVideo, isLoading }) => {
  return (
    <Container className="specific-course-screen__related-courses-block">
      <CoursesCarousel
        topTitle={t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.RELATED_COURSES.TOP_TITLE')}
        mainTitle={t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.RELATED_COURSES.MAIN_TITLE')}
        courses={relatedCourses}
        onPlayCoursePreview={handlePlayVideo}
        isLoading={isLoading}
      />
    </Container>
  );
};

export default RelatedCourses;
